"use strict";

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Returns new array starting with zero, and keeping same relation between consecutive values
 *
 * @param  {Array[number]}  list
 * @return {boolean} normalized array
 */

var normalize = function normalize(array) {
  var head = array[0];
  return array.map(function (value) {
    return value - head;
  });
};

var _default = normalize;
exports["default"] = _default;